import { GodMode } from "@core/GodMode";
import { Titles } from "./Titles";

export const Categories = [
  {
    label: "Pedidos",
    alias: "orders",
    icon: "fal fa-receipt",
    variables: [
      {
        label: Titles.OrderDateAndHour,
        type: "OrderDateAndHour",
      },
      { label: Titles.OrderValue, type: "OrderValue" },
      {
        label: Titles.OrderDeliveryFee,
        type: "OrderDeliveryFee",
      },
      {
        label: Titles.OrderBrand,
        type: "OrderBrand",
      },
      {
        label: Titles.OrderUnit,
        type: "OrderUnit",
      },
      {
        label: Titles.OrderSourceData,
        type: "OrderSourceData",
      },
      {
        label: Titles.OrderOriginSale,
        type: "OrderOriginSale",
      },
      {
        label: Titles.OrderCity,
        type: "OrderCity",
      },
      {
        label: Titles.OrderState,
        type: "OrderState",
      },
      {
        label: Titles.OrderCountry,
        type: "OrderCountry",
      },
      {
        label: Titles.OrderNeighborhood,
        type: "OrderNeighborhood",
      },
      {
        label: Titles.OrderTemperature,
        type: "OrderTemperature",
      },
      {
        label: Titles.OrderThermalSensation,
        type: "OrderThermalSensation",
      },
      {
        label: Titles.OrderMoisture,
        type: "OrderMoisture",
      },
      {
        label: Titles.OrderClimaticFeature,
        type: "OrderClimaticFeature",
      },
      {
        label: Titles.OrderYear,
        type: "OrderYear",
      },
      {
        label: Titles.OrderDay,
        type: "OrderDay",
      },
      {
        label: Titles.OrderWeek,
        type: "OrderWeek",
      },
      {
        label: Titles.OrderDayWeek,
        type: "OrderDayWeek",
      },
      {
        label: Titles.OrderMonth,
        type: "OrderMonth",
      },
    ],
  },
  {
    label: "Clientes",
    alias: "customers",
    icon: "fal fa-users",
    variables: [
      {
        label: Titles.CustomerDateAndHour,
        type: "CustomerDateAndHour",
      },
      {
        label: Titles.CustomerName,
        type: "CustomerName",
      },
      {
        label: Titles.CustomerEmail,
        type: "CustomerEmail",
      },
      {
        label: Titles.CustomerPhone,
        type: "CustomerPhone",
      },
      {
        label: Titles.CustomerDoc,
        type: "CustomerDoc",
      },
      {
        label: Titles.CustomerBirthday,
        type: "CustomerBirthday",
      },
      {
        label: Titles.CustomerAge,
        type: "CustomerAge",
      },
      {
        label: Titles.CustomerLastAtt,
        type: "CustomerLastAtt",
      },
      {
        label: Titles.CustomerTotalSpend,
        type: "CustomerTotalSpend",
      },
      {
        label: Titles.CustomerQuantityOrders,
        type: "CustomerQuantityOrders",
      },
      {
        label: Titles.CustomerRFV,
        type: "CustomerRFV",
      },
      {
        label: Titles.CustomerAverageTicket,
        type: "CustomerAverageTicket",
      },
      {
        label: Titles.CustomerFrequencyOrders,
        type: "CustomerFrequencyOrders",
      },
      {
        label: Titles.CustomerDaysWithoutConversion,
        type: "CustomerDaysWithoutConversion",
      },
      {
        label: Titles.CustomerLastOrder,
        type: "CustomerLastOrder",
      },
      {
        label: Titles.CustomerMarketing,
        type: "CustomerMarketing",
      },
      {
        label: Titles.CustomerHourRegistration,
        type: "CustomerHourRegistration",
      },
      {
        label: Titles.CustomerDayRegistration,
        type: "CustomerDayRegistration",
      },
      {
        label: Titles.CustomerWeekRegistration,
        type: "CustomerWeekRegistration",
      },
      {
        label: Titles.CustomerDayWeekRegistration,
        type: "CustomerDayWeekRegistration",
      },
      {
        label: Titles.CustomerYearRegistration,
        type: "CustomerYearRegistration",
      },
      {
        label: Titles.CustomerMonthRegistration,
        type: "CustomerMonthRegistration",
      },
    ],
  },
  {
    label: "Cupons",
    alias: "coupons",
    icon: "fal fa-ticket-simple",
    variables: [
      {
        label: Titles.CouponDayAndHour,
        type: "CouponDayAndHour",
      },
      {
        label: Titles.CouponCode,
        type: "CouponCode",
      },
      {
        label: Titles.CouponType,
        type: "CouponType",
      },
      {
        label: Titles.CouponDiscount,
        type: "CouponDiscount",
      },
      {
        label: Titles.CouponMinOrder,
        type: "CouponMinOrder",
      },
      {
        label: Titles.CouponDaysExp,
        type: "CouponDaysExp",
      },
      {
        label: Titles.CouponExpDate,
        type: "CouponExpDate",
      },
      {
        label: Titles.CouponExpDateReminder,
        type: "CouponExpDateReminder",
      },
      {
        label: Titles.CouponHour,
        type: "CouponHour",
      },
      {
        label: Titles.CouponDay,
        type: "CouponDay",
      },
      {
        label: Titles.CouponWeek,
        type: "CouponWeek",
      },
      {
        label: Titles.CouponDayWeek,
        type: "CouponDayWeek",
      },
      {
        label: Titles.CouponMonth,
        type: "CouponMonth",
      },
      {
        label: Titles.CouponYear,
        type: "CouponYear",
      },
    ],
  },
  {
    label: "Produtos",
    alias: "products",
    icon: "fal fa-pot-food",
    variables: [
      {
        label: Titles.ProductDayAndHour,
        type: "ProductDayAndHour",
      },
      {
        label: Titles.ProductSKU,
        type: "ProductSKU",
      },
      {
        label: Titles.ProductName,
        type: "ProductName",
      },
      {
        label: Titles.ProductQuantity,
        type: "ProductQuantity",
      },
      {
        label: Titles.ProductHour,
        type: "ProductHour",
      },
      {
        label: Titles.ProductValue,
        type: "ProductValue",
      },
      {
        label: Titles.ProductSize,
        type: "ProductSize",
      },
      {
        label: Titles.ProductCategory,
        type: "ProductCategory",
      },
      {
        label: Titles.ProductYear,
        type: "ProductYear",
      },
      {
        label: Titles.ProductMonth,
        type: "ProductMonth",
      },
      {
        label: Titles.ProductDay,
        type: "ProductDay",
      },
      {
        label: Titles.ProductWeek,
        type: "ProductWeek",
      },
      {
        label: Titles.ProductDayWeek,
        type: "ProductDayWeek",
      },
    ],
  },
  {
    label: "Perfis",
    alias: "profiles",
    icon: "fal fa-id-card",
    visible: GodMode.isGodMode,
    variables: [
      {
        label: Titles.ProfileRFV,
        type: "ProfileRFV",
      },
      {
        label: Titles.ProfileClimate,
        type: "ProfileClimate",
      },
      {
        label: Titles.ProfileMomentWeek,
        type: "ProfileMomentWeek",
      },
      {
        label: Titles.ProfileMomentDay,
        type: "ProfileMomentDay",
      },
      {
        label: Titles.ProfileSeason,
        type: "ProfileSeason",
      },
      {
        label: Titles.ProfileTemperature,
        type: "ProfileTemperature",
      },
    ],
  },
];
